export enum enumFormControlType {
  INPUT,
  RADIO_BUTTON,
  CHECKBOX_INPUT,
  SELECT,
  DATE_PICKER,
  PHONE_INPUT,
}
